import { useEffect, useState } from "react";
import { PageHero } from "./MarketingLayout";
import EnquiryForm from "@/components/EnquiryForm";
import { endpoints } from "@/lib/api";
import { MapPin, Mail } from "lucide-react";

export function News() {
  const [news, setNews] = useState([]);
  useEffect(() => { endpoints.news().then(setNews).catch(() => {}); }, []);
  return (
    <div>
      <PageHero eyebrow="Latest updates" title="News"
        subtitle="Announcements, mini salon recaps and everything on the road to 2027." />
      <section className="max-w-7xl mx-auto px-6 pb-24 grid md:grid-cols-3 gap-6">
        {news.map((n, i) => (
          <article key={n.id} className="border border-white/10 bg-[#121212] card-hover overflow-hidden" data-testid={`news-${i}`}>
            <div className="aspect-[16/10] overflow-hidden">
              <img src={n.image} alt={n.title} className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <div className="font-heading uppercase text-xs text-[#ffd600] mb-2">{new Date(n.date).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" })}</div>
              <h3 className="font-heading text-xl uppercase text-white leading-tight">{n.title}</h3>
              <p className="text-[#8a8d91] mt-2 font-body text-sm">{n.excerpt}</p>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}

export function Contact() {
  return (
    <div>
      <PageHero eyebrow="Get in touch" title="Contact"
        subtitle="Questions about the event, media enquiries or anything else? Drop us a line." />
      <section className="max-w-5xl mx-auto px-6 pb-24 grid lg:grid-cols-2 gap-10">
        <div>
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <Mail className="text-[#ff7a1a] mt-1" size={22} />
              <div>
                <div className="font-heading uppercase text-white">Email</div>
                <div className="text-[#8a8d91] font-body">info@perthautosalon.com</div>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <MapPin className="text-[#ff7a1a] mt-1" size={22} />
              <div>
                <div className="font-heading uppercase text-white">Venue</div>
                <div className="text-[#8a8d91] font-body">Perth Convention and Exhibition Centre<br />21 Mounts Bay Rd, Perth WA 6000</div>
              </div>
            </div>
          </div>
        </div>
        <EnquiryForm testid="contact-form" endpoint="/contact" successMsg="Message sent" fields={[
          { name: "name", label: "Full name", required: true },
          { name: "email", label: "Email", type: "email", required: true },
          { name: "subject", label: "Subject" },
          { name: "message", label: "Your message", type: "textarea", required: true },
        ]} />
      </section>
    </div>
  );
}
